import { LightningIcon, CheckIcon } from '@/ui/icons';

function KeepSiteLiveModal( {
	isOpen,
	onClose,
	onConfirm,
	timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 },
	isOfferExpired = false,
	isProBusinessPlan = false,
} ) {
	if ( ! isOpen ) {
return null;
}

	return (
		<div
			className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
			onClick={ onClose }
		>
			<div
				className="bg-gradient-to-br from-white to-orange-50 rounded-2xl max-w-2xl w-full shadow-2xl relative"
				onClick={ ( e ) => e.stopPropagation() }
			>
				<button
					onClick={ onClose }
					className="absolute top-6 right-6 text-gray-400 hover:text-gray-600 transition-colors"
					aria-label="Close modal"
				>
					<svg
						className="w-6 h-6"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={ 2 }
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>

				{ /* Content */ }
				<div className="p-8">
					{ ! isOfferExpired && (
						<div className="flex gap-2 mb-4">
							<div className="flex flex-col items-center bg-gray-50 rounded-md px-4 py-1 min-w-fit border border-gray-200">
								<span className="text-lg text-gray-900 font-semibold">
									{ String( timeLeft.days ).padStart(
										2,
										'0'
									) }
								</span>
								<span className="text-xs text-gray-600">
									DD
								</span>
							</div>

							<div className="flex flex-col items-center bg-gray-50 rounded-md px-4 py-1 min-w-fit border border-gray-200">
								<span className="text-lg text-gray-900 font-semibold">
									{ String( timeLeft.hours ).padStart(
										2,
										'0'
									) }
								</span>
								<span className="text-xs text-gray-600">
									HRS
								</span>
							</div>

							<div className="flex flex-col items-center bg-gray-50 rounded-md px-4 py-1 min-w-fit border border-gray-200">
								<span className="text-lg text-gray-900 font-semibold">
									{ String( timeLeft.minutes ).padStart(
										2,
										'0'
									) }
								</span>
								<span className="text-xs text-gray-600">
									MIN
								</span>
							</div>

							<div className="flex flex-col items-center bg-gray-50 rounded-md px-4 py-1 min-w-fit border border-gray-200">
								<span className="text-lg text-gray-900 font-semibold">
									{ String( timeLeft.seconds ).padStart(
										2,
										'0'
									) }
								</span>
								<span className="text-xs text-gray-600">
									SEC
								</span>
							</div>

							<div className="flex items-center gap-2 ml-auto">
								<span className="w-2 h-2 bg-red-500 rounded-full"></span>
								<span className="text-sm font-bold text-red-600">
									OFFER EXPIRING SOON
								</span>
							</div>
						</div>
					) }

					{ /* Main Heading with Icon */ }
					<div className="flex items-start gap-1 mb-1">
						<LightningIcon />
						<h2 className="text-2xl font-semibold text-gray-900">
							Launch Your Site for{ ' ' }
							{ isProBusinessPlan ? '$0' : '$1' }
						</h2>
					</div>

					{ /* Subheading */ }
					<p className="text-gray-600 mb-3 text-base leading-relaxed">
						Your site is on a temporary domain. Launch it now to
						keep it live & public.
					</p>

					{ /* Features Grid */ }
					<div className="grid grid-cols-2 gap-4 mb-6 bg-white p-5 rounded-lg z-index-10 shadow-xs">
						{ /* Left Column */ }
						<div className="space-y-5">
							<div className="flex items-center gap-2">
								<CheckIcon />
								<span className="text-gray-600 font-small">
									Live on the internet in minutes
								</span>
							</div>

							<div className="flex items-center gap-2 mt-0">
								<CheckIcon />
								<span className="text-gray-600 font-small">
									Free SSL included
								</span>
							</div>
						</div>

						{ /* Right Column */ }
						<div className="space-y-5">
							<div className="flex items-center gap-2 mt-0">
								<CheckIcon />
								<span className="text-gray-600 font-small">
									No technical setup
								</span>
							</div>

							<div className="flex items-center gap-2">
								<CheckIcon />
								<span className="text-gray-600 font-small">
									Edit anytime after launch
								</span>
							</div>
						</div>
					</div>

					{ /* Pricing Section */ }
					<div className="flex items-center gap-3 mb-6">
						<div className="text-gray-700 font-small">
							Get started for{ ' ' }
							{ isProBusinessPlan ? (
								<span className="text-green-600">free</span>
							) : (
								'$1'
							) }{ ' ' }
							for 3 months. Renews at $119/year.
						</div>
					</div>

					{ /* CTA Button */ }
					<button
						onClick={ onConfirm }
						className="w-full bg-orange-500 hover:bg-orange-600 text-white p-4 rounded-md transition-colors duration-200 text-md font-semibold shadow-lg"
					>
						Keep My Site Live for{ ' ' }
						{ isProBusinessPlan ? 'Free' : '$1' }
					</button>
				</div>
			</div>
		</div>
	);
}

export default KeepSiteLiveModal;
